import { useState, useCallback } from 'react';
import { useServices } from 'services';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { AsyncButton } from '@component';

export const ForgotPasswordForm = () => {
  const { auth } = useServices();
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const sendPasswordRecoveryEmail = useCallback(
    ({ email }, { setSubmitting }) => {
      setSubmitting(true);
      setError('');
      setMessage('');
      auth
        .sendPasswordResetEmail(email)
        .then(() => {
          setMessage('The email has been sent. Please follow the link in the email.');
        })
        .catch(err => {
          setError(err.message);
        })
        .finally(() => {
          setSubmitting(false);
        });
    },
    [auth]
  );

  const validate = values => {
    const errors = {};
    if (!values.email) {
      errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = 'Invalid email address';
    }
    return errors;
  };

  return (
    <div className="w-full" style={{ maxWidth: '450px' }}>
      <h3 className="font-medium text-3xl mb-8">Forgot Password</h3>
      <p className="text py-2 w-full text-text-medium">
        Please enter the email address registered with us. You will receive a link to create a new password.
      </p>
      <Formik initialValues={{ email: '' }} validate={validate} onSubmit={sendPasswordRecoveryEmail}>
        {() => (
          <>
            <Form>
              <Field className="login-input w-full" type="email" name="email" placeholder="Email" />
              <ErrorMessage className="text-error-200" name="email" component="div" />

              <AsyncButton type="submit" className="btn btn-brand btn-elevate btn-icon-sm mt-12 w-full">
                Submit
              </AsyncButton>
            </Form>
          </>
        )}
      </Formik>
      {!!error && <div className="text-error-200 pt-4">{error}</div>}
      {!!message && <div className="text-primary-700 pt-4">{message}</div>}
    </div>
  );
};
